var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeStepsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1494,
    height: 665,
    viewBox: "0 0 1494 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.05176 709.855V660.146L36 635.289L79.0508 660.146V709.855L36 734.712L-7.05176 709.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9482 634.855V585.146L79 560.289L122.051 585.146V634.855L79 659.712L35.9482 634.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.948 709.855V660.146L208 635.289L251.051 660.146V709.855L208 734.712L164.948 709.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.948 634.855V585.146L251 560.289L294.051 585.146V634.855L251 659.712L207.948 634.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.948 559.855V510.146L380 485.289L423.051 510.146V559.855L380 584.712L336.948 559.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.948 484.855V435.146L337 410.289L380.051 435.146V484.855L337 509.712L293.948 484.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.948 484.855V435.146L251 410.289L294.051 435.146V484.855L251 509.712L207.948 484.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.948 484.855V435.146L165 410.289L208.051 435.146V484.855L165 509.712L121.948 484.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9482 559.855V510.146L122 485.289L165.051 510.146V559.855L122 584.712L78.9482 559.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.05176 559.855V510.146L36 485.289L79.0508 510.146V559.855L36 584.712L-7.05176 559.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-50.0518 484.855V435.146L-7 410.289L36.0508 435.146V484.855L-7 509.712L-50.0518 484.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-50.0518 334.855V285.146L-7 260.289L36.0508 285.146V334.855L-7 359.712L-50.0518 334.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.948 559.855V510.146L208 485.289L251.051 510.146V559.855L208 584.712L164.948 559.855Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.95 84.1445V133.854L1455 158.711L1498.05 133.854V84.1445L1455 59.2881L1411.95 84.1445Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.95 84.1445V133.854L1369 158.711L1412.05 133.854V84.1445L1369 59.2881L1325.95 84.1445Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.95 9.14453V58.8545L1326 83.7109L1369.05 58.8545V9.14453L1326 -15.7119L1282.95 9.14453Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.95 234.145V283.854L1455 308.711L1498.05 283.854V234.145L1455 209.288L1411.95 234.145Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.95 159.145V208.854L1412 233.711L1455.05 208.854V159.145L1412 134.288L1368.95 159.145Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.95 159.145V208.854L1326 233.711L1369.05 208.854V159.145L1326 134.288L1282.95 159.145Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.95 9.14453V58.8545L1240 83.7109L1283.05 58.8545V9.14453L1240 -15.7119L1196.95 9.14453Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M957.145 576.948H1006.85L1031.71 620L1006.85 663.051H957.145L932.288 620L957.145 576.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M957.145 490.948H1006.85L1031.71 534L1006.85 577.051H957.145L932.288 534L957.145 490.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M882.145 447.948H931.854L956.711 491L931.854 534.051H882.145L857.288 491L882.145 447.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.14 576.948H1156.85L1181.71 620L1156.85 663.051H1107.14L1082.29 620L1107.14 576.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.14 533.948H1081.85L1106.71 577L1081.85 620.051H1032.14L1007.29 577L1032.14 533.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.14 447.948H1081.85L1106.71 491L1081.85 534.051H1032.14L1007.29 491L1032.14 447.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M882.145 361.948H931.854L956.711 405L931.854 448.051H882.145L857.288 405L882.145 361.948Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStepsImage);
export default __webpack_public_path__ + "static/media/three_steps_image.8e534e33c3a3e4aaf7fa88716ca38569.svg";
export { ForwardRef as ReactComponent };